<!--  -->
<template>
  <div class='robot-moduarl1'>  
    <h3>{{objData.title}}</h3>
    <div class="qufen">
      <p>{{objData.left}}</p>
      <p>{{objData.right}}</p>
    </div>
    <ul>
      <li  v-for="(item,index) in objData.ullist" :key="index">
        <p>{{item.p1}}</p>
        <div>
          <img :src="item.src" alt="">
          <h4>{{item.title}}</h4>
        </div>
        <p>{{item.p2}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import Text from '../utils/text'
export default {
  name:'',
  components: {},
  props:{},
  data() {
     return {
   objData:{}
     };
  },
  computed: {},
  watch: {},
  created() {
    this.objData = Text.websiteText['Robot'].modular1
    console.log(this.objData)
  },
  mounted() {

  },
  //方法集合
  methods: {

  },
}
</script>
<style lang='scss' scoped>
  //@import url(); 引入公共css类
  .robot-moduarl1{
    h3{
      font-size:36px;
      color:#333;
      text-align: center;
      font-weight: bold;
      margin-top:40px;
      line-height:80px;
    }
    ul{
      margin:0 32px;
      li{
        @include flex($just:space-between);
        padding:40px 0;
        border-bottom:1px solid #d2d2d2;
        p{
          width:225px;
          font-size:24px;
          color:#666;
          line-height:40px;
        }
        div{
          text-align:center;
          h4{
            color:#519efe;
            font-size:24px;
            margin-top:10px;
          }
          img{
            width:74px;
            height:74px;
          }
        }
      }
      li:last-child{
        border-bottom:none;
      }
    }
    .qufen{
      @include flex($just:space-between); 
      margin:40px 0;
      p{
        width:50%;
        text-align:center;
        font-size:28px;
        color:#333;
        font-weight: bold;
      }
    }
  }
</style>